module.exports = __webpack_public_path__ + "static/media/IMG_7322.651cfa0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_7322.jpg
// module id = 162
// module chunks = 0